<div class="d-flex flex-row justify-content-between align-items-center search-container">
  <div class="d-flex flex-row search-field">
    <div class="search-title">Invite your onsite team</div>
    <input type="text" style="display: none" />

    <nb-form-field class="flex-grow-1" [nbSpinner]="processing" #searchField>
      <input
        [name]="uniqueId"
        [id]="uniqueId"
        [autocomplete]="uniqueId"
        type="text"
        nbInput
        fullWidth
        placeholder="Add crew members by their email address..."
        [(ngModel)]="term"
        #searchBox
        (keyup.enter)="invite(); searchBox.focus()"
        (focus)="term = term"
        [nbPopover]="template"
        [nbPopoverContext]="{ list: list }"
        nbPopoverPlacement="bottom"
        nbPopoverTrigger="noop"
        [nbPopoverOffset]="5"
      />
      <mat-icon nbSuffix matTooltip="Invite your onsite crew members by typing in their email address." matTooltipPosition="above">help_outline</mat-icon>
    </nb-form-field>
  </div>
  <button class="appearance-filled size-small shape-rectangle status-primary nb-transition" nbButton status="primary" (click)="openCrewSystem()" size="small">
    Open Crew System
  </button>
</div>

<ng-template #template let-data>
  <nb-card class="search-results" *ngIf="data.list.length" [ngStyle]="{ width: searchField.elementRef.nativeElement.offsetWidth + 'px' }">
    <nb-card-body class="search-results-list">
      <ngx-invite-item
        *ngFor="let member of data.list; let i = index"
        [member]="member"
        [alternative]="false"
        [selectMode]="true"
        (selected)="selectTerm($event)"
      ></ngx-invite-item>
    </nb-card-body>
  </nb-card>
</ng-template>
